// extracted by mini-css-extract-plugin
export default {"farm":"FarmLife_farm__nnT4g","container":"FarmLife_container__BvOB6","wrapper":"FarmLife_wrapper__jmSe2","exit":"FarmLife_exit__FFi1S","background":"FarmLife_background__nztg-"};